import { Components, menuClasses, Theme } from '@mui/material';
import { grey, white } from '../../theme/palette/colors';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiMenu to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/menu#css
 */
export const MuiMenu: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    PaperProps: {
      elevation: 1,
    },
  },
  styleOverrides: {
    root: ({ theme }) => {
      const isLight = theme.palette.mode === 'light';
      return {
        [`& .${menuClasses.paper}`]: {
          minWidth: '161px',
          borderRadius: theme.shape.popoverRadius,
          backgroundColor: theme.featureFlags.panwRebrandStubYear
            ? theme.palette.background.popover
            : isLight
              ? white
              : grey[900],
        },
      };
    },
  },
};
